'use client'

import HeroChaos from './HeroChaos'
import { HeroConstellation, HeroMorning, HeroCommand, HeroOrbit } from './HeroVariants'

export default function HeroViz({ variant = 'chaos', speed = 1 }) {
  switch (variant) {
    case 'constellation': return <HeroConstellation speed={speed} />
    case 'morning':       return <HeroMorning speed={speed} />
    case 'command':       return <HeroCommand speed={speed} />
    case 'orbit':         return <HeroOrbit speed={speed} />
    default:              return <HeroChaos speed={speed} />
  }
}
